class CollectionSpotlightCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prevButton = this.querySelector('[data-carousel-prev]');
    this.nextButton = this.querySelector('[data-carousel-next]');

    this.prevButton?.addEventListener('click', () => this.scrollByPage(-1));
    this.nextButton?.addEventListener('click', () => this.scrollByPage(1));
  }

  scrollByPage(direction) {
    if (!this.track) return;
    this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
  }
}

customElements.define('collection-spotlight-carousel', CollectionSpotlightCarousel);
